import Vue from 'vue';
import moment from 'moment';

Vue.filter('shortenFileName', function (value, len = 30) {
	var ext = value.substring(value.lastIndexOf(".") + 1, value.length).toLowerCase();
	var filename = value.substring(0, value.lastIndexOf('.'));

	if(filename.length <= len) {
		return value;
	}

	filename = filename.substr(0, len) + (value.length > len ? '[...]' : '');
	return filename + '.' + ext;
})

Vue.filter('number', function (value, precision = 0) {
	if (value == null) return null;

	value = value.toString().replace(/[^\d.-]/g, '');

	value = parseFloat(value).toFixed(precision);

	return value == null ? null : value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
})

Vue.filter('shortenNumber', function (value) {
    if (value < 1e3) return value;
    // Could use 'if (n < 1e6)' if you like
    if (value >= 1e3 && value < 1e6) return +(value / 1e3).toFixed(1) + "K";
    // Could use 'if (n < 1e9)' if you like
    if (value >= 1e6 && value < 1e9) return +(value / 1e6).toFixed(1) + "M";
    // Could use 'if (n < 1e12)' if you like
    if (value >= 1e9 && value < 1e12) return +(value / 1e9).toFixed(1) + "B";
    if (value >= 1e12) return +(value / 1e12).toFixed(1) + "T";
});

Vue.filter('date', function (value, format = 'MM/DD/YYYY') {
	return value == null ? null : moment(value).format(format);
})

Vue.filter('time', function (value, format = 'hh:mma') {
	return value == null ? null : moment(value).format(format);
})

Vue.filter('nl2br', function (value) {
    return value == null ? null : (value + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
})

export default {}
